/**
 * @see https://www.twilio.com/docs/api/errors
 */
const enum TwilioErrorCodes {
  /**
   * Generic unknown Twilio error.
   *
   * @see https://www.twilio.com/docs/api/errors/31000
   */
  GenericError = 31000,

  /**
   * Connection error.
   *
   * A connection error that occurred during the call.
   *
   * @see https://www.twilio.com/docs/api/errors/31005
   */
  ConnectionError = 31005,

  /**
   * Connection declined error.
   *
   * @see https://www.twilio.com/docs/api/errors/31002
   */
  ConnectionDeclinedError = 31002,

  /**
   * Invalid JWT token error.
   *
   * @see https://www.twilio.com/docs/api/errors/31204
   */
  InvalidJWTTokenError = 31204,

  /**
   * JWT token expired error.
   *
   * @see https://www.twilio.com/docs/api/errors/31205
   */
  JWTTokenExpiredError = 31205,

  /**
   * User media permission error.
   *
   * Triggered when Twilio accesses the user's microphone and the user has
   * previously denied the permission request.
   *
   * @see https://www.twilio.com/docs/voice/sdks/javascript/migrating-to-js-voice-sdk-20#update-error-codes
   */
  PermissionDeniedError = 31401,

  /**
   * User media access failure.
   *
   * Triggered when Twilio fails in accessing the user's media. The browser
   * and end-user allowed permissions, however getting the media failed. Usually
   * this is due to bad constraints, but can sometimes fail due to browser, OS or hardware issues. It can also
   * fail when the user is offline.
   *
   * @see https://www.twilio.com/docs/voice/sdks/javascript/migrating-to-js-voice-sdk-20#update-error-codes
   */
  UserMediaFailError = 31402,

  /**
   * Media connection failed or Media activity ceased
   *
   * Raised by the Client or Server whenever a media connection fails or raised
   * by the Client whenever it detects that media has stopped flowing.
   *
   * @see https://www.twilio.com/docs/api/errors/53405
   */
  ICEConnectionFailError = 53405,
}

export default TwilioErrorCodes
